const LOADING_MESSAGES = {
  default: "Estamos preparando todo para ti...",
  loadingData:
    "Estamos organizando la informacion para mostrarte una vista clara.",
  loadingAccountDetail:
    "Estamos cargando el detalle de la cuenta para que puedas continuar con calma.",
  loadingPaymentMethods: "Estamos consultando los metodos de pago disponibles.",
  loadingPlanningProjects: "Estamos cargando los proyectos activos.",
  loadingEnvironmentConfiguration:
    "Estamos cargando la configuracion ambiental disponible.",
  loadingUrbanConfiguration:
    "Estamos preparando la configuracion de servicios urbanos.",
  loadingSupportOptions:
    "Estamos preparando las opciones de soporte para ayudarte mejor.",
  loadingPoll:
    "Estamos cargando el cuestionario para que puedas responderlo sin interrupciones.",
  loadingCustomerContext:
    "Estamos validando tu contexto de cliente y permisos.",
  loadingAccountingAdjustment:
    "Estamos cargando el ajuste contable solicitado.",
  processingRequest: "Estamos procesando tu solicitud con seguridad.",
  processingOrder: "Estamos procesando la operacion. Gracias por tu paciencia.",
  processingPayment: "Estamos validando y procesando el pago.",
  connectingBankGateway:
    "Estamos conectando con el banco para validar la operacion.",
  verifyingPermissions: "Estamos verificando tus permisos y acceso.",
};

export const getLoadingMessage = (key, fallback) => {
  if (!key) return fallback || LOADING_MESSAGES.default;
  return LOADING_MESSAGES[key] || fallback || LOADING_MESSAGES.default;
};

export default LOADING_MESSAGES;
